import Joi from 'joi';

export default Joi.object({
	weight: Joi.number()
		.integer()
		.positive()
		.error(() => ({
			message: 'Váha musí být celé kladné číslo!',
		})),
	height: Joi.number()
		.integer()
		.positive()
		.error(() => ({
			message: 'Výška musí být celé kladné číslo!',
		})),
});
